import { Component, Inject } from '@angular/core';
import { DpDatepickerComponent } from '../../common-component/dp-datepicker/dp-datepicker.component';
import { ProfileDataService } from '../../services/raintree/Transmission/profile-data.service';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import {
  FormGroup,
  FormControl,
  Validators,
  ReactiveFormsModule,
  FormBuilder,
  PatternValidator,
} from '@angular/forms';
import { PincodeDetailsService } from '../../services/raintree/Transmission/pincode-details.service';
import { PincodeDetailsData } from '../../services/raintree/interfaces/pincode';
import { OtpDialogComponent } from './otp-dialog/otp-dialog.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { verify } from 'node:crypto';
import { CommonModule } from '@angular/common';
import { error } from 'node:console';
import { interval, Subscription } from 'rxjs';
@Component({
  selector: 'app-dp-profile',
  standalone: true,
  imports: [DpDatepickerComponent, ReactiveFormsModule, CommonModule],
  templateUrl: './dp-profile.component.html',
  styleUrl: './dp-profile.component.scss',
})
export class DpProfileComponent {
  public isMobileDevice: boolean = false;
  public isLoading: boolean = true;
  public isPicLoading: boolean = false;
  public profileData: any;
  profileYear: string = '2021';
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  selectedFile: File | null = null;
  permissiomDetails: any = [];
  profileContactNumber: string = '';
  profileUpdatedContactNumber: string = '';
  public isStateReadonly: boolean = true;
  public isDistrictReadonly: boolean = true;
  districtList: any = [];
  editDetails: any = {
    contactNumber: '',
    email: '',
    address: '',
    pincode: '',
    state: '',
    district: '',
  };
  public profileForm!: FormGroup;
  public roleDetails: any;
  showSavBtn: boolean = false;
  showCancel: boolean = false;
  profilePicUrl: any;
  showEdit: boolean = false;
  isUserVerfied: boolean = true;
  verifiedEmailSession: string = '';
  verifiedMobileSession: string = '';
  sessionId: string = '';
  initialValues: any = {};
  pincodeList: any = []
  stateList: any[] = []

  private timerSubcription: Subscription | null = null;

  constructor(
    // @Inject(MAT_DIALOG_DATA)
    private isMobile: CommonUtilService,
    private getProfileData: ProfileDataService,
    private getProfilePic: ProfileDataService,
    private picUploadService: ProfileDataService,
    private formBuilder: FormBuilder,
    private _pincodeDetails: PincodeDetailsService,
    private dialog: MatDialog,
    private toaster: ToastrService // private dialogRef: MatDialogRef<OtpDialogComponent>
  ) {
    this.profileForm = new FormGroup({
      firstName: new FormControl(
        { value: '', disabled: true },
        [Validators.required]
      ),
      lastName: new FormControl(
        { value: '', disabled: true },
        [Validators.required]
      ),
      contactNumber: new FormControl(
        { value: '', disabled: true },
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern(/^\d{10}$/),
        ]
      ),
      updatedContactNumber: new FormControl({ value: '', disabled: true }),
      email: new FormControl(
        { value: '', disabled: true },
        [Validators.required, Validators.email]
      ),
      fCode: new FormControl({ value: '', disabled: true }),
      phlMemberName: new FormControl({ value: '', disabled: true }),
      address: new FormControl(
        { value: '', disabled: true },
        [Validators.required]
      ),
      pincode: new FormControl(
        { value: '', disabled: true },
        [Validators.required, Validators.maxLength(6)]
      ),
      district: new FormControl(
        { value: '', disabled: true },
        [Validators.required]
      ),
      state: new FormControl(
        { value: '', disabled: true },
        [Validators.required]
      ),
    });

  }

  ngOnInit() {
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.fetchProfileData();

    this.profileForm.get('pincode')?.valueChanges.subscribe((value) => {
      if (
        value &&
        value.length === 6 &&
        this.initialValues.pincode !== undefined &&
        this.showEdit
      ) {
        this.onEnteringPincode(value);
      }
    });

  }

  ngOnDestroy() {
    if (this.timerSubcription) {
      this.timerSubcription.unsubscribe()
    }
    localStorage.removeItem('dpVerifySession')

  }

  fetchProfileData() {
    this.getProfileData.getProfileData().subscribe({
      next: (response: any) => {
        this.profileData = response.data;
        let updatedPhnNo = '';
        let phNo = this.profileData['contact_number'];
        if (this.profileData.verified === 1) {
          updatedPhnNo = this.profileData['contact_number2'];
          this.profileUpdatedContactNumber = updatedPhnNo;
        }
        const phlFullName =
          this.profileData.phl_mem_name +
          ' ' +
          this.profileData.phl_mem_surname;

        this.profileContactNumber = phNo;
        if (
          this.profileData.profilePic &&
          this.profileData.profilePic.length > 0
        ) {
          this.profilePicUrl = this.profileData.profilePic;
        }

        this.profileForm.setValue({
          firstName: this.profileData.first_name,
          lastName: this.profileData.last_name,
          contactNumber: this.profileContactNumber,
          email: this.profileData.verifiedEmailId,
          fCode: this.profileData.family_code,
          phlMemberName: phlFullName,
          address: this.profileData.address,
          pincode: this.profileData.pincode,
          district: this.profileData.district_name,
          state: this.profileData.state_name,
          updatedContactNumber: this.profileUpdatedContactNumber,
        });



        this.initialValues = {
          firstName: this.profileData.first_name,
          lastName: this.profileData.last_name,
          contactNumber: this.profileContactNumber,
          email: this.profileData.verifiedEmailId,
          fCode: this.profileData.family_code,
          phlMemberName: phlFullName,
          address: this.profileData.address,
          pincode: this.profileData.pincode,
          district: this.profileData.district_name,
          state: this.profileData.state_name,
          updatedContactNumber: this.profileUpdatedContactNumber,
        };

        this.roleDetails = this.profileData.roleLocationList;
        let updatedDetails: any = [];
        this.roleDetails = this.roleDetails.forEach((item: any) => {
          let roleNames = updatedDetails.find(
            (group: any) => group.role === item.drm_role_name
          );
          if (!roleNames) {
            roleNames = { role: item.drm_role_name, stateNames: [] };
            updatedDetails.push(roleNames);
          }
          let stateGroup = roleNames.stateNames.find(
            (detail: any) => detail.state === item.durlm_state
          );
          if (!stateGroup) {
            stateGroup = { state: item.durlm_state, expand: false, active: [] };
            roleNames.stateNames.push(stateGroup);
          }
          // if (item.durlm_status === 'Active')
          stateGroup.active.push(
            item.durlm_district === '' || item.durlm_district === null
              ? 'All'
              : item.durlm_district
          );
          // else
          //   stateGroup.inactive.push(item.durlm_district === '' || item.durlm_district === null ? 'All' : item.durlm_district);
        });
        this.roleDetails = updatedDetails;
        this.isLoading = false;
      },
      error: (error: any) => { },
    });
  }

  hasChanges(): boolean {
    return this.profileForm.dirty;
  }

  restrictOtpInput(event: KeyboardEvent): void {
    const input = event.key;
    const pattern = /^[0-9]*$/;
    if (pattern.test(input) || input === 'Backspace') {
      return;
    } else {
      event.preventDefault();
    }
  }

  restrictEmailInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;

    const pattern = /^[a-zA-Z0-9@._-]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length >= 50) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  getAllDistricts(districts: any) {
    return districts.join(', ');
  }
  public onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      // this.uploadFile();
    }
  }
  onExpandClick(event: any, role: any) {
    const roleName = this.roleDetails.find((item: any) => item.role === role);
    roleName.stateNames[event].expand = true;
    this.roleDetails.forEach((item: any) => {
      if (item.role !== role) {
        item.stateNames.forEach((state: any, index: any) => {
          state.expand = false;
        });
      }

      if (item.role === role) {
        item.stateNames.forEach((state: any, index: any) => {
          if (index !== event) state.expand = false;
        });
      }
    });
  }
  public onClickUpload() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }
  onCloseClick(event: any, role: any) {
    const roleName = this.roleDetails.find((item: any) => item.role === role);
    roleName.stateNames[event].expand = false;
  }
  public uploadFile() {
    if (this.selectedFile) {
      this.isPicLoading = true;
      this.picUploadService.uploadProfilePic(this.selectedFile).subscribe({
        next: (response: any) => {
          this.getProfilePic.getProfileData().subscribe({
            next: (response: any) => {
              this.profilePicUrl = response.data.profilePic;
              this.isPicLoading = false;
            },
            error: (error: any) => { },
          });
        },
        error: (error: any) => {
          this.toaster.error(error);
        },
      });
    }
  }
  onEdit(type: any) {
    if (type == 'number') {
      if (
        this.profileForm.get('contactNumber')?.value !==
        this.initialValues.contactNumber
      ) {
        const dialogRef = this.dialog.open(OtpDialogComponent, {
          data: {
            type: 'number',
            currentTime: this.timer,
            dpMobileNo: this.profileForm.get('updatedContactNumber')?.value,
            currentNo: this.profileForm.get('contactNumber')?.value,
            isUserVerfied: this.isUserVerfied,
          },
        });
        dialogRef.afterClosed().subscribe((value) => {
          if (value.type == 'mobileVerify') {
            if (value.pendingTime > 0) {
              this.isUserVerfied = value.verified;
              this.startTimer(value.pendingTime);
            } else {
              this.isUserVerfied = true
              this.timerSubcription?.unsubscribe()
            }
          }
          if (value.type == 'finalUpdate') {
            this.profileForm.patchValue({
              contactNumber: value.contactNumber,
            });

            this.verifiedMobileSession = value.mobileSessionId;
            this.sessionId = value.sessionId;

            this.showEdit = true;
            this.showSavBtn = true;
            this.editDetails = {
              contactNumber: this.profileForm.get('contactNumber')?.value,
              mobileSessionId: this.verifiedMobileSession,
              SessionId: this.sessionId,
              address: this.profileForm.get('address')?.value,
              pincode: this.profileForm.get('pincode')?.value,
              state: this.profileForm.get('state')?.value,
              district: this.profileForm.get('district')?.value,
            };
            this.updateProfileData(this.editDetails);
          } else if (value.type == 'dpVerify') {
            this.startTimer(value.pendingTime);
          }
        });
      }
    } else if (type == 'email') {
      if (
        this.profileForm.get('email')?.value !== this.initialValues.email &&
        this.profileForm.get('email')?.value !== ''
      ) {
        const dialogRef = this.dialog.open(OtpDialogComponent, {
          data: {
            type: 'email',
            dpMobileNo: this.profileForm.get('updatedContactNumber')?.value,
            currentEmail: this.profileForm.get('email')?.value,
            currentTime: this.timer,
            isUserVerfied: this.isUserVerfied,
          },
        });
        dialogRef.afterClosed().subscribe((value) => {
          if (value.type == 'mobileVerify') {
            this.startTimer(value.pendingTime);
            if (value.pendingTime > 0) {
              this.isUserVerfied = value.verified;
            } else {
              this.isUserVerfied = true
            }
          }
          if (value.type == 'finalUpdate') {
            this.profileForm.patchValue({
              email: value.email,
            });
            this.verifiedEmailSession = value.emailSessionId;
            this.sessionId = value.sessionId;

            this.showEdit = true;
            this.showSavBtn = true;
            this.editDetails = {
              email: this.profileForm.get('email')?.value,
              emailSessionId: this.verifiedEmailSession,
              SessionId: this.sessionId,
              address: this.profileForm.get('address')?.value,
              pincode: this.profileForm.get('pincode')?.value,
              state: this.profileForm.get('state')?.value,
              district: this.profileForm.get('district')?.value,
            };
            this.updateProfileData(this.editDetails);
          } else if (value.type == 'dpVerify') {
            this.startTimer(value.pendingTime);
          }
        });
      }
    } else if (type == 'both') {
      if (
        this.profileForm.get('email')?.value !== this.initialValues.email &&
        this.profileForm.get('contactNumber')?.value !==
        this.initialValues.contactNumber
      ) {
        const dialogRef = this.dialog.open(OtpDialogComponent, {
          data: {
            type: 'both',
            dpMobileNo: this.profileForm.get('updatedContactNumber')?.value,
            currentEmail: this.profileForm.get('email')?.value,
            currentNo: this.profileForm.get('contactNumber')?.value,
            currentTime: this.timer,
            isUserVerfied: this.isUserVerfied,
          },
        });
        dialogRef.afterClosed().subscribe((value) => {
          if (value.type == 'mobileVerify') {
            if (value.pendingTime > 0) {
              this.isUserVerfied = value.verified;
              this.startTimer(value.pendingTime);
            } else if (value.pendingTime == 0) {
              this.isUserVerfied = true
              this.timerSubcription?.unsubscribe()
            }
          }
          if (value.type == 'finalUpdate') {
            this.profileForm.patchValue({
              email: value.email,
              contactNumber: value.contactNumber,
            });
            this.verifiedEmailSession = value.emailSessionId;
            this.verifiedMobileSession = value.mobileSessionId;
            this.sessionId = value.sessionId;

            this.showSavBtn = true;
            this.editDetails = {
              contactNumber: this.profileForm.get('contactNumber')?.value,
              email: this.profileForm.get('email')?.value,
              mobileSessionId: this.verifiedMobileSession,
              emailSessionId: this.verifiedEmailSession,
              SessionId: this.sessionId,
              address: this.profileForm.get('address')?.value,
              pincode: this.profileForm.get('pincode')?.value,
              state: this.profileForm.get('state')?.value,
              district: this.profileForm.get('district')?.value,
            };
            this.updateProfileData(this.editDetails);
          } else if (value.type == 'dpVerify') {
            this.startTimer(value.pendingTime);
          }
        });
      }
    } else if (type == 'addressSection') {
      this.editDetails = {
        address: this.profileForm.get('address')?.value,
        pincode: this.profileForm.get('pincode')?.value,
        state: this.profileForm.get('state')?.value,
        district: this.profileForm.get('district')?.value,
      };
      this.showEdit = false
      this.updateProfileData(this.editDetails);
    }
  }

  editProfile() {
    this.showEdit = !this.showEdit;
    if (this.showEdit) {
      this.showCancel = true;
      this.showSavBtn = false;
      this.profileForm.get('address')?.enable();
      this.profileForm.get('pincode')?.enable();
      this.profileForm.get('email')?.enable();
      this.profileForm.get('contactNumber')?.enable();
    }
  }

  cancelEdit() {
    if (this.showCancel) {
      this.showCancel = false;
      this.showSavBtn = false;
      this.profileForm.markAsPristine();
      this.showEdit = false
      this.districtList.length = 0
      this.profileForm.patchValue({ ...this.initialValues });
      this.profileForm.get('address')?.disable();
      this.profileForm.get('pincode')?.disable();
      this.profileForm.get('email')?.disable();
      this.profileForm.get('contactNumber')?.disable();
    }
  }
  saveInput() {
    if (
      this.profileForm.get('contactNumber')?.value !==
      this.initialValues.contactNumber &&
      this.profileForm.get('contactNumber')?.value.length > 9 &&
      this.profileForm.get('email')?.value !== this.initialValues.email &&
      this.profileForm.get('contactNumber')?.value !== '' &&
      this.profileForm.get('email')?.value !== '' &&
      !this.profileForm.get('email')?.invalid
    ) {
      this.onEdit('both');
    } else if (
      this.profileForm.get('contactNumber')?.value !==
      this.initialValues.contactNumber &&
      this.profileForm.get('contactNumber')?.value.length > 9 &&
      this.profileForm.get('contactNumber')?.value !== ''
    ) {
      this.onEdit('number');
    } else if (
      this.profileForm.get('email')?.value !== this.initialValues.email &&
      this.profileForm.get('email')?.value !== '' &&
      !this.profileForm.get('email')?.invalid

    ) {
      this.onEdit('email');
    } else if (
      (this.profileForm.get('address')?.value != this.initialValues.address && this.profileForm.get('address')?.value != '') ||
      (this.profileForm.get('pincode')?.value != this.initialValues.pincode && this.profileForm.get('pincode')?.value != '') ||
      this.profileForm.get('district')?.value != this.initialValues.district
    ) {
      this.onEdit('addressSection');
    }

    if (
      this.profileForm.value === this.initialValues
    ) {
      this.toaster.success('Please update any field to save your changes.');
    } else if (
      this.profileForm.get('contactNumber')?.value == '' ||
      this.profileForm.get('email')?.value == '' ||
      this.profileForm.get('pincode')?.value == '' ||
      this.profileForm.get('address')?.value == '' ||
      (this.profileForm.get('contactNumber')?.value == '' &&
        this.profileForm.get('email')?.value == '' &&
        this.profileForm.get('pincode')?.value == '' &&
        this.profileForm.get('address')?.value == '')
    ) {
      this.toaster.success('Edit fields cannot be empty. Please check.');
    } else if (
      this.profileForm.get('email')?.invalid &&
      this.profileForm.get('email')?.touched
    ) {
      this.toaster.success('Email is invalid. please Check.');
    }
  }
  onEnteringPincode(pin: any) {
    const pincode: string = pin;

    if (pincode != null && pincode != '') {
      this.isStateReadonly = true;
      // this.isDistrictReadonly = true;
      // this.profileForm.get('district')?.reset()
      if (pincode && pincode.length === 6) {
        this._pincodeDetails.fetchPincodeDetails(pincode).subscribe({
          next: (response: any) => {
            this.isStateReadonly = false;

            this.pincodeList = response.data
            this.stateList = Object.keys(this.pincodeList)
            console.log(this.stateList);


            if (this.stateList.length == 2) {
              this.profileForm.get('state')?.enable()

            } else {
              this.districtList = Object.keys(this.pincodeList[this.stateList[0]])
              console.log(this.districtList);
              this.profileForm.patchValue({
                state: this.stateList[0]

              })
              if (this.districtList.length == 1) {
                this.profileForm.patchValue({
                  district: this.districtList[0]
                })
              } else {
                this.profileForm.get('district')?.enable()
              }
              // }

            }
            // this.districtList = response.data.districts;
            // this.isStateReadonly = false;
            // if (this.districtList.length == 1) {
            //   this.profileForm.patchValue({
            //     state: response.data.states[0],
            //     district: this.districtList[0],
            //   });
            // } else {
            //   this.profileForm.patchValue({ state: response.data.states[0] });
            //   this.profileForm.get('district')?.enable();
            // }
          },
          error: (error) => {
            this.toaster.error(error);
          },
        });
      }
    } else if (pincode == null || pincode == '') {
      this.isStateReadonly = false;
      this.isDistrictReadonly = false;
      this.profileForm.get('district')?.reset()
      this.profileForm.get('state')?.reset()

    }
  }

  getDistrict(event: any) {
    const value = (event.target).value
    this.isStateReadonly = false;

    this.districtList = Object.keys(this.pincodeList[value])
    this.profileForm.patchValue({
      district: this.districtList[0]
    })


  }

  updateProfileData(bodyObj: any) {
    bodyObj = {
      address: this.editDetails.address,
      districtName: this.editDetails.district,
      stateName: this.editDetails.state,
      email: this.editDetails.email,
      emailSession: this.editDetails.emailSessionId,
      pinCode: Number(this.editDetails.pincode),
      contactNumber: this.editDetails.contactNumber,
      mobileSession: this.editDetails.mobileSessionId,
      SessionId: this.editDetails.SessionId,
    };
    this.showEdit = false

    const cleanedObj = Object.fromEntries(
      Object.entries(bodyObj).filter(([key, value]) => value !== '')
    );
    this.getProfileData.sendUpdatedProfileData(cleanedObj).subscribe({
      next: (res) => {
        this.toaster.success(res.message);
        this.showSavBtn = false;
        this.profileForm.get('address')?.disable();
        // this.profileForm.get('pincode')?.disable();
        // this.profileForm.get('district')?.disable();
        this.profileForm.get('email')?.disable();
        this.profileForm.get('contactNumber')?.disable();
        this.showCancel = false
        this.districtList.length = 0
        this.fetchProfileData();
      },
      error: (error) => {
        this.cancelEdit()
        this.toaster.error(error);
      },
    });
  }

  timer: number = 0;
  startTimer(time: number) {
    if (time > 0) {
      this.timerSubcription = interval(1000).subscribe((value) => {
        time--;
        this.timer = time;
      });
    } else {
      time = this.timer;
      if (this.timerSubcription) {
        this.timerSubcription.unsubscribe();
      }
    }
  }
}
